
export const URLS = {
    auth: "/identity/auth",
    sso_auth: "/auth",
    documents: "/identity/documents",
    sso_documents: "/documents",
    accounts:"/identity/accounts",
    sso_accounts: "/accounts",
    questions: "/identity/auth/questions",
    cancel: "/identity/sdk/cancel",
    processAccount: "/account-opening/accounts",
    customerById: "/identity/customer/",
    customerByPhone: "/identity/customer/phone/",
	getUser: "/identity/user",
	uploadSignature: "/ussd/services/upload-signature",
	cardManagement: "/ussd/services/card-management",
	checkUssd: "/ussd/admin/check-session/{phone}",
	getSession: "/ussd/admin/get-session/{uid}",
}; 